/* eslint-disable eslint-comments/disable-enable-pair */

/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { maestroApiCall } from '@michelin/central-provider';
import {
  FetchMakesParams,
  FetchModelsParams,
  FetchOptionsParams,
  FetchStatesParams,
  FetchYearsParams,
} from '@michelin/core-profile-ui-tools';
import { FetchTireSizesParams } from '@michelin/core-profile-ui-tools/build/components/UFOVehicleDetailsForm/types';
import { SelectOption, getOptions } from '@michelin/select-options-provider';
import hash from 'object-hash';
import { useQueryClient } from 'react-query';
import { makesAPIType, modelsAPIType, optionsAPIType, tireSizesAPIType, yearsAPIType } from 'types/APITypes';
import { buildOptionsAndValuesFromArray, buildOptionsAndValuesFromObject } from './Utils';

export const useGetYears = () => {
  const queryClient = useQueryClient();
  const fn = async (params: FetchYearsParams) => {
    try {
      const response = await queryClient.fetchQuery<SelectOption[]>(
        ['useGetYears', hash(params)],
        () => maestroApiCall(yearsAPIType(), params),
        { cacheTime: 3600 },
      );
      if (!response) return [];
      return buildOptionsAndValuesFromArray(response);
    } catch (e) {
      return [];
    }
  };
  return fn;
};

export const useGetMakes = () => {
  const queryClient = useQueryClient();
  const fn = async (params: FetchMakesParams) => {
    try {
      const response = await queryClient.fetchQuery<SelectOption[]>(
        ['useGetMakes', hash(params)],
        () => maestroApiCall(makesAPIType(), params),
        { cacheTime: 3600 },
      );
      if (!response) return [];
      return buildOptionsAndValuesFromObject(response);
    } catch (e) {
      return [];
    }
  };
  return fn;
};

export const useGetModels = () => {
  const queryClient = useQueryClient();
  const fn = async (params: FetchModelsParams) => {
    try {
      const response = await queryClient.fetchQuery<SelectOption[]>(
        ['useGetModels', hash(params)],
        () => maestroApiCall(modelsAPIType(), params),
        { cacheTime: 3600 },
      );
      if (!response) return [];
      return buildOptionsAndValuesFromObject(response);
    } catch (e) {
      return [];
    }
  };
  return fn;
};

export const useGetOptions = () => {
  const queryClient = useQueryClient();
  const fn = async (params: FetchOptionsParams) => {
    try {
      const response = await queryClient.fetchQuery<SelectOption[]>(
        ['useGetOptions', hash(params)],
        () => maestroApiCall(optionsAPIType(), params),
        { cacheTime: 3600 },
      );
      if (!response) return [];
      return buildOptionsAndValuesFromObject(response);
    } catch (e) {
      return [];
    }
  };
  return fn;
};

export const useGetTireSizes = () => {
  const queryClient = useQueryClient();
  const fn = async (params: FetchTireSizesParams) => {
    try {
      const response = await queryClient.fetchQuery<SelectOption[]>(
        ['useGetTireSizes', hash(params)],
        () => maestroApiCall(tireSizesAPIType(), params),
        { cacheTime: 3600 },
      );
      if (!response) return [];
      return buildOptionsAndValuesFromObject(response);
    } catch (e) {
      return [];
    }
  };
  return fn;
};

async function getStates(params: FetchStatesParams) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (params.country_code === 'ca') {
    return getOptions('ca_provinces');
  }
  return getOptions('us_states');
}

export const useGetStates = () => {
  return getStates;
};
